module.exports = __webpack_public_path__ + "static/thumb-energy-api-a88d408591816314dc0c5c44707de847.png";